import cloneDeep from 'lodash/cloneDeep'
import initialState from './state.js'

export default {
  resetRaffle(state) {
    Object.keys(state).map((key) => {
      if (key === 'generateWinner') return
      state[key] = cloneDeep(initialState[key])
    })
  },
  setRaffleType(state, payload) {
    state.raffle.rules.type = payload
  },
  setRaffleValue(state, payload) {
    state.raffle.rules.value = payload
  },
  setRaffleCumulative(state, payload) {
    state.raffle.rules.cumulative = payload
  },
  setRaffleDates(state, { startDate, endDate }) {
    state.raffle.start_date = startDate
    state.raffle.end_date = endDate
  },
  SET_GENERATE_WINNER(state, payload) {
    state.generateWinner = payload
  },
}
